import * as React from 'react';
import {
  BookOpenIcon,
  Building2Icon,
  CodeIcon,
  CuboidIcon,
  FileTextIcon,
  RocketIcon,
  SendHorizonalIcon,
  ZapIcon,
} from 'lucide-react';

const routes = {
  marketing: {
    Contact: '/contact',
    Blog: '/blog',
    Story: '/about',
    TermsOfUse: '/terms-of-use',
    PrivacyPolicy: '/privacy-policy',
    CookiePolicy: '/cookie-policy',
    Pricing: '/pricing',
    Features: {
      IntentEngine: '/features/intent-engine',
      Battlecard: '/features/battlecard',
      UkCompanies: '/features/uk-companies',
      McpApi: '/features/mcp-api',
    }
  },
  docs: {
    Home: '/docs',
    GettingStarted: '/docs',
    Reports: '/docs',
  }
};

import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TikTokIcon,
  XIcon
} from '@workspace/ui/components/brand-icons';


export const MENU_LINKS = [
  {
    title: 'Product',
    items: [
      {
        title: 'Intent Engine',
        description: 'Autonomous prospect discovery on a schedule.',
        icon: <ZapIcon className="size-5 shrink-0" />,
        href: routes.marketing.Features.IntentEngine,
        external: false
      },
      {
        title: 'Battlecard',
        description: 'AI dossier for every prospect meeting.',
        icon: <FileTextIcon className="size-5 shrink-0" />,
        href: routes.marketing.Features.Battlecard,
        external: false
      },
      {
        title: 'UK Companies',
        description: 'Search 5M Companies House records instantly.',
        icon: <Building2Icon className="size-5 shrink-0" />,
        href: routes.marketing.Features.UkCompanies,
        external: false
      },
      {
        title: 'MCP / API',
        description: 'Software 3.0 — agents can operate your pipeline.',
        icon: <CodeIcon className="size-5 shrink-0" />,
        href: routes.marketing.Features.McpApi,
        external: false
      }
    ]
  },
  {
    title: 'Resources',
    items: [
      {
        title: 'Contact',
        description: 'Reach out for assistance and beta access.',
        icon: <SendHorizonalIcon className="size-5 shrink-0" />,
        href: routes.marketing.Contact,
        external: false
      },
      {
        title: 'Docs',
        description: 'Learn how to use the KithFlow platform.',
        icon: <BookOpenIcon className="size-5 shrink-0" />,
        href: routes.docs.Home,
        external: false
      },
    ]
  },
  {
    title: 'Pricing',
    href: routes.marketing.Pricing,
    external: false
  },
  {
    title: 'Blog',
    href: routes.marketing.Blog,
    external: false
  },
];

export const FOOTER_LINKS = [
  {
    title: 'Product',
    links: [
      { name: 'Intent Engine', href: routes.marketing.Features.IntentEngine, external: false },
      { name: 'Battlecard', href: routes.marketing.Features.Battlecard, external: false },
      { name: 'UK Companies', href: routes.marketing.Features.UkCompanies, external: false },
      { name: 'MCP / API', href: routes.marketing.Features.McpApi, external: false }
    ]
  },
  {
    title: 'Resources',
    links: [
      { name: 'Contact', href: routes.marketing.Contact, external: false },
      { name: 'Docs', href: routes.docs.Home, external: false },
    ]
  },
  {
    title: 'About',
    links: [
      { name: 'Story', href: routes.marketing.Story, external: false },
      { name: 'Blog', href: routes.marketing.Blog, external: false },
    ]
  },
  {
    title: 'Legal',
    links: [
      { name: 'Terms of Use', href: routes.marketing.TermsOfUse, external: false },
      { name: 'Privacy Policy', href: routes.marketing.PrivacyPolicy, external: false },
      { name: 'Cookie Policy', href: routes.marketing.CookiePolicy, external: false }
    ]
  }
];

export const SOCIAL_LINKS = [
  {
    name: 'X (formerly Twitter)',
    href: '#',
    icon: <XIcon className="size-4 shrink-0" />
  },
  {
    name: 'LinkedIn',
    href: '#',
    icon: <LinkedInIcon className="size-4 shrink-0" />
  },
  {
    name: 'Facebook',
    href: '#',
    icon: <FacebookIcon className="size-4 shrink-0" />
  },
  {
    name: 'Instagram',
    href: '#',
    icon: <InstagramIcon className="size-4 shrink-0" />
  },
  {
    name: 'TikTok',
    href: '#',
    icon: <TikTokIcon className="size-4 shrink-0" />
  }
];

export const DOCS_LINKS = [
  {
    title: 'Getting Started',
    icon: <CuboidIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      { title: 'Introduction', href: '/docs', items: [] },
      { title: 'Account Setup', href: '/docs/getting-started', items: [] },
    ]
  },
  {
    title: 'Core Features',
    icon: <RocketIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      { title: 'Intent Engine', href: '/docs/intent-engine', items: [] },
      { title: 'Battlecard', href: '/docs/battlecard', items: [] },
      { title: 'UK Companies', href: '/docs/uk-companies', items: [] },
    ]
  },
  {
    title: 'Developer',
    icon: <CodeIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      { title: 'MCP / API', href: '/docs/mcp-api', items: [] },
    ]
  }
];
